var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextInput',{attrs:{"props":_vm.input_props,"required_rule":_vm.required_rule},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }